import { darken, Theme, useTheme } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import createStyles from "@material-ui/core/styles/createStyles";
import { observer } from "mobx-react-lite";
import React, { ReactChild, ReactChildren, useContext } from "react";
import { NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { routerContext } from "../../../index";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link: {
      textDecoration: "none",
      color: theme.palette.text.primary
    },
    active: {
      "& li": {
        color: theme.palette.text.primary
      }
    }
  })
);

export interface NestedListLinkPropsInternal {
  children: React.ReactElement<any> | ReactChild | ReactChildren;
  to: string;
  icon?: any;
}

const NestedListLinkComponent = observer(
  (props: NestedListLinkPropsInternal) => {
    const classes = useStyles();
    const theme = useTheme();
    const router = useContext(routerContext);

    const { children, to } = props;

    const isActivePath = router.location.pathname == to;

    return (
      <NavLink
        to={to}
        className={classes.link}
        activeClassName={classes.active}
      >
        <ListItem
          button={true}
          style={
            isActivePath
              ? {
                  backgroundColor: darken(theme.palette.background.paper, 0.2)
                }
              : { backgroundColor: "" }
          }
        >
          <ListItemText>{children}</ListItemText>
        </ListItem>
      </NavLink>
    );
  }
);

export const NestedListLinkWhenDrawerCollapsed = NestedListLinkComponent;
